<template>
    <v-card class="my-4 py-4">
        <v-card-text class="py-0">
            <slot />
        </v-card-text>
        <v-row class="mx-0 pa-4" justify="center" align="center">
            <div class="h5">{{title}}</div>
        </v-row>
    </v-card>
</template>
<script>
export default {
  props: {
    title: {
      type: String,
      required: true,
    },

   
  },
};
</script>